// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__3oorC","collection-title":"styles-m__collection-title__1Lg9d","text":"styles-m__text__1-G61"};